/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  DetachBindingRequestBody,
  DetachBindingRequestBody$Outbound,
  DetachBindingRequestBody$outboundSchema,
} from "../components/detachbindingrequestbody.js";

export type DetachBindingSecurity = {
  projectSlugHeaderGramProject?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type DetachBindingRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  detachBindingRequestBody: DetachBindingRequestBody;
};

/** @internal */
export type DetachBindingSecurity$Outbound = {
  "project_slug_header_Gram-Project"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const DetachBindingSecurity$outboundSchema: z.ZodMiniType<
  DetachBindingSecurity$Outbound,
  DetachBindingSecurity
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function detachBindingSecurityToJSON(
  detachBindingSecurity: DetachBindingSecurity,
): string {
  return JSON.stringify(
    DetachBindingSecurity$outboundSchema.parse(detachBindingSecurity),
  );
}

/** @internal */
export type DetachBindingRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
  DetachBindingRequestBody: DetachBindingRequestBody$Outbound;
};

/** @internal */
export const DetachBindingRequest$outboundSchema: z.ZodMiniType<
  DetachBindingRequest$Outbound,
  DetachBindingRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    detachBindingRequestBody: DetachBindingRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
      detachBindingRequestBody: "DetachBindingRequestBody",
    });
  }),
);

export function detachBindingRequestToJSON(
  detachBindingRequest: DetachBindingRequest,
): string {
  return JSON.stringify(
    DetachBindingRequest$outboundSchema.parse(detachBindingRequest),
  );
}
